package com.mshopsas.enterprise.aiw.scan.data.basket

import kotlinx.serialization.Serializable

@Serializable
data class EndBasket(
    val result: String,
    val auditCode: String
)